import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import { size as _size } from 'lodash';
import { Stage, Layer, Rect } from 'react-konva';

import ActionLink from '../builder/ActionLink';
import Spinner from '../builder/Spinner';

class PuzzleCanvas extends Component {
	constructor(props, context) {
		super(props, context);

		this.foo_columns = [];
		this.state = {
			columns:this.setLevel(props),
			fillPatternImage:null,
			full_loaded:false,
			image:props.image,
			image_w:100,
			image_h:100,
			items:[],
			positions_items:[],
			size_piece_h:0,
			size_piece_w:0,
		};

		this.size = 600;

		this.positions_items = [];

		this.move_in_sound = props.sound_fx.move_in;
		this.move_out_sound = props.sound_fx.move_out;
		if(props.stageInstance != undefined) props.stageInstance(this);

		this.default_cache_props = { pixelRatio:2, imageSmoothingEnabled:true, offset:5, drawBorder:false };
	}

	/*START SOUNDS*/
	startMovePlay() {
		this.move_in_sound.play();
	}

	endMovePlay() {
		this.move_out_sound.play();
	}
	/*END SOUNDS*/

	componentWillMount() {
		this.setLevel(this.props);
		this.calcImageSizes();
	}

	componentDidMount() {
		//this.gameInit();

		window.onresize = () => {
			this.gameInit(true);
		}
	}

	componentWillReceiveProps(props) {
		if(props.level != this.props.level || props.image != this.props.image) {
			if(props.image != this.props.image) this.state.image = props.image;
			if(props.level != this.props.level) this.state.columns = this.setLevel(props);

			this.calcImageSizes();
			this.gameInit();
		}

		if(props.to_reset != this.props.to_reset) this.resetGame();
	}

	resetGame() {
		this.setState({ full_loaded:false });
		this.removeCache();
		this.gameInit();
	}

	gameInit(from_resize) {
		if(from_resize == undefined) from_resize = false;

		if(this.props.adaptToContainer != undefined) this.props.adaptToContainer((size) => {
			this.size = size;

			if(!from_resize) {
				this.calcSquares();
				this.shuffle();
			}
			setTimeout(() => {
				this.generateCache();
			}, 1500);

			this.setState({ full_loaded:true });
		});
	}

	calcImageSizes() {
		var image = new window.Image();
		image.src = this.state.image;
		image.crossOrigin = 'Anonymous';

		image.onload = () => {
			this.setState({
				fillPatternImage:image,
				image_w:image.width,
				image_h:image.height,
				size_piece_w:image.width / this.state.columns,
				size_piece_h:image.height / this.state.columns,
			});

			this.gameInit();
		}
	}

	calcSquares() {
		this.state.items = [];

		const number_of_items = this.state.columns * this.state.columns;
		for(var i = 0; i < number_of_items; i++) {
			const x = (i % this.state.columns * 100) / this.state.columns;
			const y = (Math.floor(i / this.state.columns) * 100) / this.state.columns;
			this.state.items.push({
				position:i,
			});
		}

		const size_part = this.size / this.state.columns;

		for(var pos = 0; pos < number_of_items; pos++) {
			const ini_pos_x = Math.floor(pos % this.state.columns) * size_part;
			const ini_pos_y = Math.floor(pos / this.state.columns) * size_part;
			this.positions_items.push({
				x:ini_pos_x,
				y:ini_pos_y,
			});
		}
	}

	setLevel(props) {
		var columns;
		switch(props.level) {
			case 'hard':
				columns = 5;
				break;
			case 'normal':
				columns = 4;
				break;
			case 'easy':
			default:
				columns = 3;
				break;
		}

		this.foo_columns = [];
		for(var i = 0; i < columns - 1; i++) this.foo_columns.push("foo");

		return columns;
	}

	shuffle(cb) {
		var items = this.state.items;
		const threshold_solved_percentage = 15;//2 Pieces in Easy, 3 pieces in Medium, 4 Pieces in Hard
		if(_size(items) > 0) {
			var currentIndex = items.length, temporaryValue, randomIndex;
			// While there remain elements to shuffle...
			while(0 !== currentIndex) {
				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;

				// And swap it with the current element.
				temporaryValue = items[currentIndex];
				items[currentIndex] = items[randomIndex];
				items[randomIndex] = temporaryValue;

			}

			var correct_pieces_in_puzzle = 0;
			items.map((item,position)=>{
				if(item.position == position)correct_pieces_in_puzzle++;
			})

			const very_very_solved_in_shuffle = correct_pieces_in_puzzle / _size(items) * 100 > threshold_solved_percentage ? true : false;

			this.state.items = items;
			this.setState({ ...this.state });
			if(very_very_solved_in_shuffle){
				this.shuffle();
			}else{
				if(cb!=undefined)cb();
			}
		}
	}

	isSolved() {
		var is_solved = true;
		this.state.items.map((item, i) => {
			if(item.position !== i) is_solved = false
		});

		if(is_solved) {
			var time = false;
			const stage = this.refs['stage'];
			if(this.props.onHitResult != undefined) this.props.onHitResult();
			if(this.props.onSolve != undefined) this.props.onSolve(true,{img:stage.toDataURL()});
		}

		return is_solved;
	}

	generateCache(only_pieces) {
		if(only_pieces == undefined) only_pieces = 'all';

		let pieces_to_cache = (only_pieces == 'all') ? [...this.state.items] : [];
		if(only_pieces != 'all') {
			only_pieces.map((i) => {
				pieces_to_cache.push(this.state.items[i]);
			});
		}

		pieces_to_cache.map((value) => {
			this.refs['part_' + value.position].cache(this.default_cache_props);
		});

		this.refs.layer.draw();
	}

	removeCache(only_pieces) {
		if(only_pieces == undefined) only_pieces = 'all';

		let pieces_to_cache = (only_pieces == 'all') ? [...this.state.items] : [];
		if(only_pieces != 'all') {
			only_pieces.map((i) => {
				pieces_to_cache.push(this.state.items[i]);
			});
		}

		pieces_to_cache.map((value) => {
			if(this.refs['part_' + value.position] != undefined) {
				this.refs['part_' + value.position].clearCache();
			}
		});
	}

	handleStart(e, position) {
		const layer = this.refs.layer;
		var element = this.state.items[position];
		var rect = this.refs['part_' + element.position];
		rect.scale({ x: rect.getAttr("startScale") * 1.2,y: rect.getAttr("startScale") * 1.2});
		rect.opacity(0.5);
		rect.zIndex(_size(this.state.items) - 1);
		layer.draw();

		this.startMovePlay();
	}

	handleEnd(e, position) {
		const attrs = e.target.attrs;
		const x = attrs.x;
		const y = attrs.y;
		const items = this.state.items;
		const num_columns = this.state.columns;
		var has_changes = false;
		var init_area = 0;
		var pos_selected = -1;

		for(var pos = 0; pos < _size(items); pos++) {
			const ini_pos_x = this.positions_items[pos].x;
			const end_pos_x = this.positions_items[pos].x + this.state.size_piece_w;

			const ini_pos_y = this.positions_items[pos].y;
			const end_pos_y = this.positions_items[pos].y + this.state.size_piece_h;

			//POS 1 (Quadrant baix dreta)
			var area_x_pos_1 = (end_pos_x - x > 0) ? (end_pos_x - x) : 0;
				area_x_pos_1 = (area_x_pos_1 > this.state.size_piece_w) ? 0 : area_x_pos_1;

			var area_y_pos_1 = (end_pos_y - y > 0) ? (end_pos_y - y) : 0;
				area_y_pos_1 = (area_y_pos_1 > this.state.size_piece_h) ? 0 : area_y_pos_1;

			var area_pos_1 = area_x_pos_1 * area_y_pos_1;

			//POS 2 (Quadrant dalt dreta)
			var area_x_pos_2 =  (end_pos_x - x > 0) ? (end_pos_x - x) : 0;
				area_x_pos_2 = (area_x_pos_2 > this.state.size_piece_w) ? 0 : area_x_pos_2;

			var area_y_pos_2 = ((y + this.state.size_piece_h - ini_pos_y) > 0) ? (y + this.state.size_piece_h - ini_pos_y) : 0;
				area_y_pos_2 = (area_y_pos_2 > this.state.size_piece_h) ? 0 : area_y_pos_2;

			var area_pos_2 = area_x_pos_2 * area_y_pos_2;

			//POS 3 (Quadrant dalt esquerra)
			var area_x_pos_3 = ((x + this.state.size_piece_w - ini_pos_x) > 0) ? (x + this.state.size_piece_w - ini_pos_x) : 0;
				area_x_pos_3 = (area_x_pos_3 > this.state.size_piece_w) ? 0 : area_x_pos_3;

			var area_y_pos_3 = ((y + this.state.size_piece_h - ini_pos_y) > 0) ? (y + this.state.size_piece_h - ini_pos_y) : 0;
				area_y_pos_3 = (area_y_pos_3 > this.state.size_piece_h) ? 0 : area_y_pos_3;

			var area_pos_3 =  area_x_pos_3 * area_y_pos_3;

			//POS 4 (Quadrant baix esquerra)
			var area_x_pos_4 = ((x + this.state.size_piece_w - ini_pos_x) > 0) ? (x + this.state.size_piece_w - ini_pos_x) : 0;
				area_x_pos_4 = (area_x_pos_4 > this.state.size_piece_w) ? 0 : area_x_pos_4;

			var area_y_pos_4 = (end_pos_y - y > 0) ? (end_pos_y - y) : 0;
				area_y_pos_4 = (area_y_pos_4 > this.state.size_piece_h) ? 0 : area_y_pos_4;

			var area_pos_4 =  area_x_pos_4 * area_y_pos_4;

			if((area_pos_1 + area_pos_2 + area_pos_3 + area_pos_4) > init_area) {
				init_area = area_pos_1 + area_pos_2 + area_pos_3 + area_pos_4;
				pos_selected = pos;
			}
		}

		if(pos_selected >= 0) {
			const temporaryValue = items[position];
			items[position] = items[pos_selected];
			items[pos_selected] = temporaryValue;
			this.setState({
				items:items,
			});

			this.state.items.map((item, index) => {
				var rect = this.refs['part_' + item.position];
				rect.position({
					x:this.positions_items[index].x,
					y:this.positions_items[index].y,
				});

				rect.zIndex(1);
				rect.opacity(1);

				/*rect.to({
					duration: 0.5,
					easing: Konva.Easings.ElasticEaseInOut,
					scaleX: rect.getAttr("startScale"),
					scaleY: rect.getAttr("startScale"),
				});*/
			});

			if(this.props.onFireAttempt != undefined) this.props.onFireAttempt({
				error:(items[pos_selected].position == pos_selected) ? false : true,
			},false);

			this.removeCache([position, pos_selected]);
			this.generateCache([position, pos_selected]);

			const layer = this.refs.layer;
			layer.draw();

			this.endMovePlay();

			this.isSolved();
		}
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		if(!this.state.image) {
			return (
				<aside class="game_container is_puzzle">
					<div class="canvas_content">
						<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />
						<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
							<span>{i18n("Upload an image to create your puzzle")}</span>
							<span class="size_recommendation"><FormattedMessage id="Recommended size: {w}×{h}px" values={{w:800, h:800}} /></span>
						</div>
					</div>
				</aside>
			)
		}

		const display_hint = (this.props.display_hint != undefined) ? this.props.display_hint : false;

		const items = this.state.items;
		const canvas_size = this.size;
		const size_portion = canvas_size / this.state.columns;

		return (
			<aside class="game_container is_puzzle">
				<div class="canvas_content">
					<img src={window.cdn_url + 'img/blank_1x1.png'} class="img_pusher" alt="" />

					{(this.state.full_loaded) ? (

						!this.props.game_init ? (
							<div></div>
						):(

						<Stage className={'canvas_cont' + ((!this.state.full_loaded) ? ' not_loaded_yet' : '')} width={canvas_size} height={canvas_size} ref="stage">
							<Layer ref="layer">
								{items.map((value, index) => {
									const is_correct = (value.position == index) ? true : false;

									const x_ini = Math.floor(index % this.state.columns) * size_portion;
									const y_ini = Math.floor(index / this.state.columns) * size_portion;

									const offset_x = Math.floor(value.position % this.state.columns) * this.state.size_piece_w;
									const offset_y = Math.floor(value.position / this.state.columns) * this.state.size_piece_h;

									/** SI ES POSA DRAGABBLE A FALSE, A LA QUE LA PEÇA QUE HI HAVIA ON MOUS LA NOVA PASSA A ESTAR AUTOMÀTICAMENT BEN COLOCADA, PETA FORT (VEURE ALERT DE LA LÍNIA 265) */
									return (
										<Rect
											ref={'part_' + value.position}
											key={'item-' + index}
											x={x_ini}
											y={y_ini}
											draggable={(!is_correct || true) ? true : false}
											width={size_portion}
											height={size_portion}
											scale={{x:1,y:1}}
											startScale={1}
											fillPatternImage={this.state.fillPatternImage}
											fillPatternRepeat="no-repeat"
											fillPatternScaleX={this.size / this.state.image_w}
											fillPatternScaleY={this.size / this.state.image_h}
											fillPatternOffset={{x:offset_x, y:offset_y}}
											onDragEnd={(e) => this.handleEnd(e, index)}
											onDragStart={(e) => this.handleStart(e, index)}
											onMouseEnter={() => { document.body.style.cursor='move'; }}
											onMouseLeave={() => { document.body.style.cursor='default'; }}
										/>
									)
								})}

								{this.foo_columns.map((foo, i) => {
									const x_ini = (i + 1) * size_portion;

									return (
										<Rect
											key={'line_v-' + i}
											x={x_ini}
											y={0}
											stroke='rgba(0, 0, 0, 0.2)'
											strokeWidth={1}
											width={0}
											height={canvas_size}
										/>
									)
								})}

								{this.foo_columns.map((foo, i) => {
									const y_ini = (i + 1) * size_portion;

									return (
										<Rect
											key={'line_h-' + i}
											x={0}
											y={y_ini}
											stroke='rgba(0, 0, 0, 0.2)'
											strokeWidth={1}
											width={canvas_size}
											height={0}
										/>
									)
								})}
							</Layer>
						</Stage>
						)
					) : (
						<div class="gui_not_in_top gui_flex_center">
							<Spinner>Loading game</Spinner>
						</div>
					)}

					{(this.props.display_hint !== false) && (
						<div class="game_hint">
							<img src={this.state.image} width={canvas_size} height={canvas_size} alt="" />
						</div>
					)}
				</div>
			</aside>
		);
	}
}

export default injectIntl(PuzzleCanvas);